import { render, staticRenderFns } from "./VentanaOperacionesEscaner.vue?vue&type=template&id=96c70856"
import script from "./VentanaOperacionesEscaner.vue?vue&type=script&lang=js"
export * from "./VentanaOperacionesEscaner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports